
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment";
export default {
  components: {
    DatePicker
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Goa, Goa Tourism, Travel Guide, Watersports, Goa Beaches, Romantic Places, Waterfalls, Hidden Places, Must Visit places in Goa, Dudhsagar Waterfalls, Calangute Beach, Palolem Beach, Grand Island Goa, Old Goa Church, Bom Jesus Church, Visit goa, Things to do in Goa, Travel Agency",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title + " | Goa App",
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title + " | Goa App",
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      ],
    };
  },
  data() {
    return {
      title: 'Make your own Tour',
      description: 'Promote your tour on Goa App for free!!',
      categoriesData: null,
      categoriesList: null,
      form: {
        eventName: null,
        description: null,
        shortDesc: null,
        longDesc: null,
        inclusion: null,
        exclusion: null,
        itinerary: null,
        guidelines: null,
        numberOfPeople: null,
        numberOfNights: null,
        sellerPrice: null,
        tourType: null,
        coverImage: [],
        categoriesList: [],
        tags: {
          addTag: null,
          tagsList: []
        },
      },
      //Form error variables
      errors: {
        formError: null,
        errorMsg: "<strong>Opps! Something went wrong,</strong> please try again."
      },
      // Form submit variables
      submit: {
        loading: false,
        success: false,
        errored: false
      },
      tourTypes: [{
        name: 'International Tours',
        slug:'international-tours'
      },
      {
        name: 'Domestic Tours',
        slug:'domestic-tours'
      },
    ],
      nights: [{
        name: '2 days 1 night',
        value: 1
      }, {
        name: '3 days 2 nights',
        value: 2
      }, {
        name: '4 days 3 nights',
        value: 3
      }, {
        name: '5 days 4 nights',
        value: 4
      }, {
        name: '6 days 5 nights',
        value: 5
      }
      ]
    }
  },
  mounted() {
    this.getData();
  },

  methods: {

    async getData() {
      this.categoriesData = await fetch(this.$config.fetchUrl + '/api/activityTypes/getTypesWithCategories/').then(res => res
        .text());
      this.categoriesData = this.getCryptKey(this.categoriesData);
      this.getCategoriesList('tours')
    },

    // To get category list based on the activity type selected
    getCategoriesList(slug) {
      this.form.categoryId = [];
      // array function to find the id with matches the one selected from activity type dropdown
      let filterActivityType = this.categoriesData.find(x => x.slug === slug);
      this.categoriesList = filterActivityType.categories;
    },

    // To add tag to the tags list
    addTag(tagToAdd) {
      let tagItem = tagToAdd.toLowerCase();
      var tag = tagItem.split(',');
      const found = this.form.tags.tagsList.some(r => tag.includes(r))
      if (!found) {
        this.form.tags.tagsList.push(...tag);
      }
      else {
        this.$refs.eventForm.setErrors({
          validateTag: ['Tag already exists']
        });
        return;
      }
      this.form.tags.addTag = null;
    },

    // Remove a tag from the tag list
    removeTag(id) {
      this.form.tags.tagsList.splice(id, 1);
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload(e) {
      let uploadedFiles = this.$refs.files.files;
      /*
        Adds the uploaded file to the files array
      */
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.form.coverImage.push(uploadedFiles[i]);
      }
      if (this.form.coverImage.length < 1) {
        this.$refs.coverImage.validate(e);
      }
      else {
        this.$refs.eventForm.setErrors({
          coverImage: []
        });
      }
      this.$refs.files.value = null;
    },
    //To remove an uploaded file on click of button, and trigger the errors
    removeFiles(key) {
      this.form.coverImage.splice(key, 1);
      if (this.form.coverImage.length < 1) {
        this.$refs.eventForm.setErrors({
          coverImage: ['Cover image required']
        });
      }
      else {
        this.$refs.eventForm.setErrors({
          coverImage: []
        });
      }
    },

    getFilePreview(imageFile) {
      return URL.createObjectURL(imageFile);
    },

    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      return str;
    },

    // To clear the submit error message
    clearFormErrMsg() {
      this.errors.formError = null;
      this.submit.success = false;
      this.submit.errored = false;
    },

    // To reset the form after successful submit
    resetForm() {
      var self = this; //you need this because *this* will refer to Object.keys below`
      //Iterate through each object field, key is name of the object field`
      Object.keys(this.form).forEach(function (key, index) {
        if (typeof self.form[key] != ("object" || "array")) {
          self.form[key] = null;
        }
      });
      this.form.coverImage = [];
      this.form.categoriesList = [];
      this.form.tags.tagsList = [];
      this.$refs.eventForm.reset();
    },

    // Validate and Submit form data to a add event
    sendMessage() {
      // Clear all submit errors before API call
      this.errors.formError = null;
      this.submit.success = false;
      this.submit.errored = false;
      // Validate all fields for making the API call, throw error and not call API if validation errors are present
      this.$refs.eventForm.validate().then((success) => {
        if (!success || (this.form.tags.tagsList.length < 1 && this.form.tags.addTag != (null || ''))) {
          // run your error code here
          if (this.form.tags.tagsList.length < 1 && this.form.tags.addTag != (null || '')) {
            this.$refs.eventForm.setErrors({
              validateTag: ['Click ADD button to add the tags']
            });
          }
          this.errors.formError = "One or more incorrect fields present, please fix.";
        }
        else {
          // If Valid form
          // Create formData instance to pass the data to the API
          var formData = new FormData();
          if (this.form.coverImage && this.form.coverImage.length > 0) {
            this.form.coverImage.forEach(coverImage => {
              formData.append('gallery', coverImage);
            })
          }
          if (this.form.categoriesList && this.form.categoriesList.length > 0) {
            this.form.categoriesList.forEach(category => {
              formData.append('categories', category._id);
            })
          }
          this.form.tags.tagsList.forEach(tag => {
            formData.append('tags', tag);
          })
          formData.append("name", this.form.eventName.trim());
          formData.append("slug", this.string_to_slug(this.form.eventName.trim().toLowerCase()));
          formData.append("shortDescription", this.form.shortDesc.trim());
          if (this.form.longDesc) {
            formData.append("text", this.form.longDesc.trim());
          }
          if (this.form.guidelines)
            formData.append("guidelines", this.form.guidelines.trim());
          formData.append("inclusion", this.form.inclusion.trim());
          formData.append("exclusion", this.form.exclusion.trim());
          formData.append("itinerary", this.form.itinerary.trim());
          formData.append("tourType", this.form.tourType);
          formData.append("numberOfPeople", this.form.numberOfPeople);
          formData.append("numberOfNights", this.form.numberOfNights);
          formData.append("sellerPrice", this.form.sellerPrice);

          // Add header for the API
          const headers = {
            'Content-Type': 'multipart/form-data',
          }
          this.submit.loading = true;
          // AXIOS api call to add categories api
          this.$axios
            .post("/api/tours/", formData, { headers: headers })
            .then(response => {
              this.submit.success = true;
              this.submit.errored = false;
              this.$bvModal.show('create-event');
              this.resetForm();
            })
            .catch(error => {
              if (error.response.data) {
                if (error.response.data.toLowerCase().includes("duplicate key error")) {
                  if (error.response.data.toLowerCase().includes("name")) {
                    this.errors.errorMsg = "<strong>Event name exists,</strong> please use another name."
                  }
                }
              }
              this.submit.success = false;
              this.submit.errored = true;
            })
            .finally(() => {
              this.submit.loading = false;
            });
        }
      });
    }

  }
}
